<template>
    <div class="medical-services">
        <home-skeleton v-if="loading" style="margin-top: 30px"></home-skeleton>
        <div v-else>
            <div class="anticancer-header medical-services-header">
                <div class="anticancer-header-title">
                    <van-image src="/static/bytx/medical-services-title.svg" />
                </div>
                <div class="anticancer-header-title-tips services-title-tips">
                    <van-image src="/static/bytx/medical-services-title-tips.svg" />
                </div>
                <div class="anticancer-header_bg-icon">
<!--                    <van-image src="/static/bytx/anticancer/anticancer-header_bg-icon.svg" />-->
                </div>
            </div>
            <div class="medical-services-main-header-top">
                <div class="medical-services-main-header-top-item">
                    <van-image src="/static/bytx/ylfw/qwzj.svg" /> 全国权威专家
                </div>
                <div class="medical-services-main-header-top-item">
                    <van-image src="/static/bytx/ylfw/zphy.svg" /> 正品好药
                </div>
                <div class="medical-services-main-header-top-item">
                    <van-image src="/static/bytx/ylfw/hyzs.svg" /> 患友贴心助手
                </div>
            </div>
            <div class="clear"></div>
            <div class="medical-services-main-box">
                <van-grid column-num="3" active-color="#404040" v-model="active" :fixed="false" :border="false">
                    <van-grid-item @click="showDialog(1)" class="home-main-nav">
                        <van-image src="/static/bytx/ylfw/medical_head_icon_1@3x.png" />
                        <div class="title">咨询医生</div>
                        <div>权威专家 在线看诊</div>
                    </van-grid-item>
                    <van-grid-item @click="showDialog(2)" class="home-main-nav">
                        <van-image src="/static/bytx/ylfw/medical_head_icon_2@3x.png" />
                        <div class="title">线上开药</div>
                        <div>正品好药 快速到家</div>
                    </van-grid-item>
                    <van-grid-item @click="showDialog(3)" class="home-main-nav">
                        <van-image src="/static/bytx/ylfw/medical_head_icon_3@3x.png" />
                        <div class="title">专家推荐</div>
                        <div>全国权威专家速览</div>
                    </van-grid-item>
                </van-grid>
            </div>

            <div class="swipe">
                <van-swipe :autoplay="3000" indicator-color="#fff" v-if="banners.length > 0">
                    <van-swipe-item v-for="(item, i) in banners" :key="i" @click="goBanner(item)">
                        <a @click.prevent="toLink(item.target_url)">
                        <!-- <a :href="item.target_url.replace('https://care-yyh.com','https://care-yyh.com')"> -->
                            <img :src="item.img" alt="" />
                        </a>
                    </van-swipe-item>
                </van-swipe>
            </div>

            <div class="medical-services-section" v-for="item in module_type_2" :key="item.id">
                <van-row class="medical-services-section-box-more">
                    <h3 class="medical-services-section-box-more-title">{{ item.title }}</h3>
                    <div class="medical-services-section-box-more">
                        <div class="medical-services-section-box-more-left">
                            <van-image
                                fit="cover"
                                class="box-more-main-img"
                                :src="item.cover_img"
                                width="100%"
                                height="186"
                                @click="goTargetUrl(item)"
                            />
                        </div>
                        <div class="medical-services-section-box-more-right">
                            <van-cell
                                class="box-more-right-box"
                                title-class="medical-services-section-box-more-right-title"
                                label-class="medical-services-section-box-more-right-desc"
                                is-link
                                :icon="val.cover_img"
                                v-for="(val, i) in item.modules"
                                :key="'child' + i"
                                center
                                :title="val.title"
                                :label="val.desc"
                                @click="goTargetUrl(val)"
                            />
                            <div class="clear"></div>
                        </div>
                    </div>
                    <div class="clear"></div>
                </van-row>
            </div>
            <div class="medical-services-section">
                <van-row class="medical-services-section-box-one">
                    <div
                        class="medical-services-section-box-one-left"
                        @click="goTargetUrl(item)"
                        v-for="item in module_type_1"
                        :key="item.id"
                    >
                        <van-image fit="cover" class="box-one-main-img" :src="item.cover_img" width="162" height="74" />
                    </div>
                </van-row>
            </div>
            <div class="clear"></div>

            <div class="pre-page">
                <img src="/static/bytx/ylfw/back_home_btn.svg" @click="$toHomePage"/>
            </div>

            <van-action-sheet class="confirmDialog" v-model="showConfirmDialog">
                <img src="/static/bytx/qrcode/bytx-dev.jpg" alt="" />
                <div class="scribe-title">扫码关注“博医同行”微信公众号</div>
                <div class="scribe-desc">第一时间接收战友活动提醒</div>
            </van-action-sheet>
        </div>

        <!-- 在线咨询  || 咨询医生 -->
        <Consult ref="Refconsult" :pageType=4></Consult>
        <!-- 开药 -->
        <Prescribe ref="RefPrescribe" :pageType=4></Prescribe>
        <!-- 专家推荐 -->
        <Recommend ref="RefRecommend" :pageType=4></Recommend>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import homeSkeleton from '@/skeleton/homeSkeleton'
import { Consult, Prescribe, Recommend } from '@/components/overlay'
import {LocationHref} from '@/util/common'

export default {
    name: 'medical-services',
    components: {
        'home-skeleton': homeSkeleton,
        Consult,
        Prescribe,
        Recommend
    },
    data() {
        return {
            active: '',
            loading: true,
            value: '',
            module_type_1: [],
            module_type_2: [],
            banners: [],
            showConfirmDialog: false,
            record_id: 0
        }
    },
    methods: {
        toLink(url){
            const links = url.replace('https://care-yyh.com', '')
            LocationHref(links)
        },
        goList(row) {
            this.$router.push({
                name: row
            })
        },
        showDialog(row) {
            if (row === 1) {
                Interface.CoFootPrint(18)
                Interface.mFootPrint(1, 78,0, 4, 0, 0,0,'医疗服务-咨询医生')
                this.$refs.Refconsult.overlayShow = true
                return
            }
            if (row === 2) {
                Interface.CoFootPrint(19)
                Interface.mFootPrint(1, 79,0, 4, 0, 0,0,'医疗服务-线上开药')
                this.$refs.RefPrescribe.overlayShow = true
                return
            }
            if (row === 3) {
                Interface.CoFootPrint(20)
                Interface.mFootPrint(1, 84,0, 4, 0, 0,0,'医疗服务-专家推荐')
                this.$refs.RefRecommend.overlayShow = true
                return
            }
        },
        goDetail(item) {
            LocationHref(item.url)
        },
        goTargetUrl(item) {
            if (item.title == "临床招募"){
                Interface.CoFootPrint(22)
            }else if (item.title == "预约门诊") {
                Interface.CoFootPrint(23)
            }else if (item.title == "远程会诊"){
                Interface.CoFootPrint(24)
            }else if (item.title == "就诊指南"){
                Interface.CoFootPrint(25)
            }else if (item.title == "基因检测"){
                Interface.CoFootPrint(26)
            }


            if (item.id == 0){
              Interface.mFootPrint(item.id, 68,0, 4, 0, 0,0,'敬请期待')
              return
            }
            if (item.modules) {
              Interface.mFootPrint(item.id, 68,0, 4, 0, 0,0,item.title)
            } else if ( item.title == '远程会诊' || item.title == '就诊指南' || item.title == '基因检测') {


              Interface.mFootPrint(item.id, 68,0, 4, 0, 0,0,item.title)
            }  else {
              Interface.mFootPrint(item.id, 71,0, 4, 0, 0,0,item.title)
            }

            if (item.target_url == '') {
                this.$router.push({
                    name: 'medical-services-detail',
                    params: {
                        id: item.id
                    }
                })
            } else {
                LocationHref(item.target_url)
            }

        },
        toDoctor() {
            // Interface.footPrint(18, 0, 0, '点击首页金刚区按钮 问医生')
            LocationHref('https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=expert')
        },
        goBanner(item) {
            Interface.CoFootPrint(21)
          Interface.mFootPrint(item.id,62,0,4,0,0,0,'医疗服务轮播图')
        },
        fetch(scene) {
            if (scene === 'list') {
                Interface.getData('get', Interface.medical.list, { pageSize: 100 }).then(res => {
                    res.data.list.forEach(val => {
                        if (val.type === 1) {
                            this.module_type_1.push(val)
                        } else if (val.type === 2) {
                            this.module_type_2.push(val)
                        }
                    })
                    if (this.module_type_1.length % 2 === 1) {
                        this.module_type_1.push({
                            id: 0,
                            title: '',
                            cover_img: '/static/bytx/ylfw/medical_card_6@3x.png',
                            modules: [],
                            type: 0,
                            target_url: ''
                        })
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            } else if (scene === 'banner') {
                Interface.getData('get', Interface.banner, { type: 10 }).then(res => {
                    if(res.data.length > 0) {
                        this.banners = res.data
                    }
                })
            }
        }
    },
    created() {
        this.fetch('banner')
        this.fetch('list')
        sessionStorage.removeItem('search_data')
        Interface.getShareInfo(this, '医疗服务', '', '', 70, '',Interface.host + '/#/medical-services?source_type=1')
        Interface.getData('post',Interface.footprint, {
          id: 1,
          type: 70,
          content_type: 0,
          page_type: 4,
          source_type: 0,
          parent_id: 0,
          record_id: 0,
          title: '医疗服务'
        }).then( (res) => {
          if (res.code == 0) {
            this.record_id = res.data.record_id
          }
        })

        Interface.CoFootPrint(11)
    },
    beforeRouteLeave(to, from, next) {
      if (this.record_id) {
        Interface.mFootPrint(1, 70,0, 4, 0, 0,this.record_id,'医疗服务')
      }
      next()
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/medical-services/index.vue